// extracted by mini-css-extract-plugin
export var info = "screen1-module--info--be5f7";
export var screen1 = "screen1-module--screen1--29a5a";
export var wrapper = "screen1-module--wrapper--e382c";